var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUnitedKingdom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.25H16.75V13.75H1.25V4.25Z",
    fill: "#1E50A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.214V8H12.5452L16.75 5.42275V4.25H14.8365L10 7.214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.25H15.7933L10 7.80075V8H10.8705L16.75 4.3965V4.25Z",
    fill: "#D22F27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8368 13.75H16.75V12.577L12.5455 10H10V10.7858L14.8368 13.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7496 13.75V13.1632L11.5884 10H10.3916L16.5101 13.75H16.7496Z",
    fill: "#D22F27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.786V10H5.45475L1.25 12.5772V13.75H3.1635L8 10.786Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 13.75H2.20675L8 10.1993V10H7.1295L1.25 13.6035V13.75Z",
    fill: "#D22F27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16325 4.25H1.25V5.423L5.4545 8H8V7.21425L3.16325 4.25Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.25V4.83675L6.4115 8H7.608L1.4895 4.25H1.25Z",
    fill: "#D22F27"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.75H16.75V10.25H1.25V7.75Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 4.25H10.25V13.75H7.75V4.25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8.25H16.75V9.75H1.25V8.25Z",
    fill: "#D22F27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.25H9.75V13.75H8.25V4.25Z",
    fill: "#D22F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedKingdom);
export default __webpack_public_path__ + "static/media/flag-united-kingdom.b6306368c48f2d01b0eccc87f9264ff4.svg";
export { ForwardRef as ReactComponent };